class ParameterService {

    /*@ngInject*/
    constructor($window) {
        this.$window = $window;
        this.params = null;
    }

    getParam(paramName) {
        if(this.params===null)
            this.buildParams();

        if(typeof this.params[paramName] !== 'undefined') {
            return this.params[paramName];
        }

        return '';
    }

    buildParams() {
        this.params={};

        var hash;
        var hashes = this.$window.location.href.slice(this.$window.location.href.indexOf('?') + 1).split('&');

        for(var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            this.params[decodeURI(hash[0])]=decodeURI(hash[1]);
        }
    }
}

export default ParameterService;


// WEBPACK FOOTER //
// ./src/app/services/parameter-service.js